var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarsVisible = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6996 138.686C89.8863 137.946 89.4626 134.618 88.6152 131.29C87.7678 134.618 87.3441 137.946 83.5308 138.686C87.3441 139.425 87.7678 142.753 88.6152 146.081C89.4626 142.753 89.8863 139.425 93.6996 138.686Z",
    fill: "#FF7527"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.382 164.107C241.262 163.506 240.915 160.802 240.222 158.098C239.529 160.802 239.182 163.506 236.062 164.107C239.182 164.708 239.529 167.412 240.222 170.116C240.915 167.412 241.262 164.708 244.382 164.107Z",
    fill: "#FF7527"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9084 154.864C70.4344 154.009 70.1923 145.6 68.7396 137.762C67.2869 145.6 67.0448 154.009 58.5709 154.864C67.0448 155.719 67.2869 164.127 68.7396 171.966C70.1923 164.127 70.4344 155.719 78.9084 154.864Z",
    fill: "#FF7527"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.12 193.227C215.801 192.487 215.592 185.215 214.338 178.436C213.083 185.215 212.874 192.487 205.555 193.227C212.874 193.966 213.083 201.238 214.338 208.018C215.592 201.238 215.801 193.966 223.12 193.227Z",
    fill: "#FF7527"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3219 190.453C90.2331 189.852 90.002 183.944 88.6154 178.436C87.2287 183.944 86.9976 189.852 78.9088 190.453C86.9976 191.054 87.2287 196.963 88.6154 202.471C90.002 196.963 90.2331 191.054 98.3219 190.453Z",
    fill: "#FF7527"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.515 140.997C223.197 140.466 222.988 135.239 221.733 130.366C220.478 135.239 220.269 140.466 212.951 140.997C220.269 141.529 220.478 146.756 221.733 151.628C222.988 146.756 223.197 141.529 230.515 140.997Z",
    fill: "#FF7527"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.807 183.908C143.255 183.908 142.807 184.356 142.807 184.908C142.807 185.461 143.255 185.908 143.807 185.908V183.908ZM155.964 182.934L154.966 183.002L155.964 182.934ZM154.193 156.961L153.195 157.029L154.193 156.961ZM117.734 142.789C126.178 138.398 133.562 137.948 141.335 140.195L141.89 138.274C133.628 135.885 125.714 136.385 116.811 141.015L117.734 142.789ZM153.195 157.029L154.966 183.002L156.961 182.866L155.191 156.893L153.195 157.029ZM154.119 183.908H143.807V185.908H154.119V183.908ZM154.966 183.002C155 183.492 154.611 183.908 154.119 183.908V185.908C155.769 185.908 157.074 184.512 156.961 182.866L154.966 183.002ZM141.335 140.195C148.431 142.246 152.673 149.375 153.195 157.029L155.191 156.893C154.632 148.703 150.05 140.632 141.89 138.274L141.335 140.195Z",
    fill: "#424243"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.97 155.464C129.634 151.758 134.493 151.774 143.156 155.464",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.569 155.464C171.233 151.758 176.092 151.774 184.756 155.464",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132.063,
    cy: 156.388,
    r: 4.62216,
    fill: "#424243"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.663,
    cy: 156.388,
    r: 4.62216,
    fill: "#424243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.845 198.637C150.98 201.313 155.862 200.882 163.956 198.637",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.701 164.299C195.507 178.72 191.781 188.955 186.422 196.95C181.056 204.957 174.008 210.788 166.044 216.345C157.992 221.963 147.154 222.097 138.959 216.689C130.33 210.995 122.953 205.182 117.447 197.179C111.95 189.19 108.268 178.942 107.176 164.307C105.795 145.799 106.517 129.003 112.874 116.855C116.037 110.81 120.598 105.913 127.023 102.516C133.461 99.113 141.825 97.1865 152.631 97.1865C174.307 97.1865 186.039 103.019 192.054 114.022C195.094 119.584 196.728 126.556 197.361 134.966C197.995 143.374 197.624 153.156 196.701 164.299Z",
    stroke: "#424243",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 150.242C118.659 146.544 130.215 136.838 142.695 121.122C150.552 136.838 169.965 146.082 199.085 150.242L201.858 150.704C199.085 115.113 185.219 94.3136 151.477 89.2292C116.811 94.3136 102.482 115.113 102.482 150.704L104.793 150.242Z",
    fill: "#424243",
    stroke: "#424243",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M197.698 152.446C199.115 150.59 201.941 150.076 204.252 151.593C204.989 152.077 205.453 152.867 205.719 153.708C208.72 163.204 205.674 174.44 202.242 176.791C200.419 178.039 196.602 177.415 195.387 176.791",
    stroke: "#424243",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.641 152.446C105.224 150.59 102.398 150.076 100.088 151.593C99.3505 152.077 98.8863 152.867 98.6205 153.708C95.6195 163.204 98.6657 174.44 102.098 176.791C103.921 178.039 107.737 177.415 108.953 176.791",
    stroke: "#424243",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.938,
    cy: 90.1538,
    rx: 19.4131,
    ry: 13.4043,
    fill: "#424243"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.616 89.6179C156.065 89.5873 155.593 90.0095 155.563 90.5609C155.532 91.1124 155.954 91.5842 156.506 91.6149L156.616 89.6179ZM156.506 91.6149C160.686 91.8471 162.586 91.9605 164.424 92.2731C166.27 92.5868 168.054 93.1007 172.015 94.1746L172.538 92.2444C168.641 91.1874 166.727 90.6359 164.76 90.3013C162.785 89.9656 160.756 89.8479 156.616 89.6179L156.506 91.6149Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.483,
    cy: 99.0135,
    rx: 11.4241,
    ry: 12.5137,
    transform: "rotate(-51.7823 136.483 99.0135)",
    fill: "#424243"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarsVisible);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ears_visible.43690bd7adc92b32504bb06f33d09ae2.svg";